import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ number, label, color = "#adff01" }) => (
  <Reveal className="mb-10 flex items-center gap-4 md:mb-14">
    <span
      className="font-display text-sm tracking-widest md:text-base"
      style={{ color }}
    >
      {number}
    </span>
    <span className="h-[2px] w-10" style={{ background: color }} />
    <span className="text-xs font-bold uppercase tracking-[0.3em] text-zinc-400 md:text-sm">
      {label}
    </span>
  </Reveal>
);
